import { CancellablePromise } from "../interfaces/api";

export function isPromise(obj: any): obj is Promise<any> {
  return !!obj && typeof obj.then === "function";
}

export function isCancellablePromise(obj: any): obj is CancellablePromise<any> {
  return !!obj && typeof obj.then === "function" && typeof obj.cancel === "function";
}
